<div class="toolbar">
    <select id="template" name="template" [(ngModel)]="selectedTemplate" (change)="templateChanged()">
        <option *ngFor="let option of templateOptions" [value]="option">{{ option }}</option>
    </select>
    <div *ngIf="_includeToolbarButtons">
        <button class="toolbar-btn" (click)="_includeSegmentSection = ! _includeSegmentSection">Segments</button>
        <button class="toolbar-btn" (click)="_showStreetNames = ! _showStreetNames">Streets</button>
        <button class="toolbar-btn" (click)="_includeScaleSection = ! _includeScaleSection">Scale</button>
    </div>
</div>

<div class="segment-nav" *ngIf="segmentData && selectedSegment">
    <div class="nav-button button-left" *ngIf="selectedSegment.prev">
        <button type="button" class="btn btn-default"
            title="{{selectedSegment.prev.streetName}}, Segment: {{selectedSegment.prev.number}}"
            (click)="changeSegment(selectedSegment.prev)">
            &lt;
        </button>
    </div>
    <div class="nav-section-center">
        <div class="segment-text"> {{ segmentData?.countyCode }} - {{ segmentData?.countyName }}, {{ selectedSegment?.stateRouteNumber }}, {{ selectedSegment?.streetName }}, Segment: {{ selectedSegment?.segmentNumber }}
        </div>
        <div *ngIf="selectedSegment.otherSide">
            <button type="button" class="btn btn-default btn-xs btn-switch-sides"
                title="{{selectedSegment.otherSide.streetName}}, Segment: {{selectedSegment.otherSide.number}}"
                (click)="switchSides(selectedSegment.otherSide)">
                Switch Sides
            </button>
        </div>
    </div>
    <div class="nav-button button-right" *ngIf="selectedSegment.next">
        <button type="button" class="btn btn-default"
            title="{{selectedSegment.next.streetName}}, Segment: {{selectedSegment.next.number}}"
            (click)="changeSegment(selectedSegment.next)">
            &gt;
        </button>
    </div>
</div>

<div class="container">
    <div #primary class="primary">
        <ng-container *ngIf="!showSelect; else showForm">
            Select a point to continue.
        </ng-container>
        <ng-template #showForm>
            <div class="section segments" *ngIf="segmentData && includeSegmentSection">
                <div class="isle-intersection-label" *ngIf="showStreetNames">
                    <div class="isle-intersection-label-above"
                        *ngFor="let intersection of segmentData.intersections; let i = index;"
                        [ngStyle]='{ "left": (((intersection.cumulativeOffset - segmentData.segments[0].cumOffsetBegin ) / segmentData.length * 100 )+ "%") }'>
                        <div *ngIf="i%2 !=0">{{ intersection.streetName }} </div>
                    </div>
                </div>
                <div class="isle-segment">
                    <div class="isle-intersection-marker">
                        <div class="isle-intersection-marker-above"
                            *ngFor="let intersection of segmentData.intersections; let i = index;"
                            [ngStyle]='{ "left": (((intersection.cumulativeOffset - segmentData.segments[0].cumOffsetBegin ) / segmentData.length * 100 )+ "%") }'>
                            <div *ngIf="i%2 !=0">|</div>
                        </div>
                    </div>
                    <div class="isle-segment-bar">
                        <div class="segments-line"></div>
                        <span title="Segment - {{ selectedSegment.segmentNumber }}; {{selectedSegment.length}} (ft.)"> {{ selectedSegment.segmentNumber }} {{ mileMarkerDescription }} </span>
                    </div>
                    <div class="isle-intersection-marker">
                        <div class="isle-intersection-marker-below"
                            *ngFor="let intersection of segmentData.intersections; let i = index;"
                            [ngStyle]='{ "left": (((intersection.cumulativeOffset - segmentData.segments[0].cumOffsetBegin ) / segmentData.length * 100 )+ "%") }'>
                            <div *ngIf="i%2 ===0">|</div>
                        </div>
                    </div>
                </div>
                <div class="isle-intersection-label" *ngIf="showStreetNames">
                    <div class="isle-intersection-label-below"
                        *ngFor="let intersection of segmentData.intersections; let i = index;"
                        [ngStyle]='{ "left": (((intersection.cumulativeOffset - segmentData.segments[0].cumOffsetBegin ) / segmentData.length * 100 )+ "%") }'>
                        <div *ngIf="i%2 ===0">{{ intersection.streetName }} </div>
                    </div>
                </div>
            </div>

            <!-- TODO - This could be converted to use flexbox styles -->

            <div class="section scale" *ngIf="includeScaleSection">
                <div class="isle-scale" *ngIf="segmentData">
                    <div *ngIf="segmentData?.length > 0">
                        <div class='isle-scale-title'>Scale Bar(ft)</div>
                        <div class='isle-scale-total'>Total - {{ segmentData.segments[0].length }}(ft)</div>
                        <div class="clearfix"></div>
                        <div *ngFor="let offset of segmentData.scale" class='isle-scale-mark'
                            [ngStyle]='{ "width": offset.width + "%" }'>|</div>
                        <div class="clearfix"></div>
                        <div class='isle-scale-bar'></div>
                        <div class="clearfix"></div>
                        <div class='isle-scale-labels'>
                            <div *ngFor="let offset of segmentData.scale" class='isle-scale-label'
                                [ngStyle]='{ "width": offset.width + "%" }'>
                                <span>{{ offset.value < segmentData.length ? offset.value : '&nbsp;' }}</span>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section attributes" *ngIf="segmentData">
                <ng-container *ngFor="let attrib of segmentData.attributes">
                    <div class='isle-attribute' *ngIf="attrib.item.length > 0 && !attrib.hasAllHidden">
                        <div class='isle-attribute-title'>{{ attrib.description }}</div>
                        <div class="attrib-divider"></div>

                        <!-- Begin Items -->
                        <ng-container *ngFor="let item of attrib.item">
                            <div *ngIf=" !item?.hidden">
                                <div class='isle-attribute-year'
                                     *ngIf="attrib.tablePartitionedByYear && !item.isSameYearAsLast">
                                    {{ item.facts[0] }}
                                </div>
                                <div class="clearfix" *ngIf="item.isOverlap"></div>
                                <div class='isle-attribute-padding' *ngIf="item.padding > 0"
                                     [ngStyle]='{ "width": (item.padding + "%") }'>&nbsp;</div>
                                <div class='isle-attribute-point' *ngIf="item.attributeBarSize == 0"
                                     [title]="item?.toolTip"
                                     (click)="selectItemDetails($event, item)"
                                     [ngClass]="{ 'selected': (selectedAttributeItem == item && itemDetailsOpen) }">
                                    &diams;
                                </div>
                                <div class='isle-attribute-bar' *ngIf="item.attributeBarSize != 0 && !item.hidden"
                                     [title]="item?.toolTip" (click)="selectItemDetails($event, item)"
                                     [ngClass]="{ 'selected': (selectedAttributeItem == item && itemDetailsOpen) }"
                                     [ngStyle]='{ "width": (item.width + "%"), "background-color": ("#" + item.color) }'>
                                    <span>{{ item.title }}</span>
                                </div>

                            </div>
                        </ng-container>
                        <!-- End Items -->

                        <div class="clearfix"></div>
                        <div class="attrib-divider" *ngIf="attrib.tablePartitionedByYear"></div>
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </div>
    <div #secondary class="secondary" [hidden]="!itemDetailsOpen">
        <div class="isle-attribute-detail">
            <h4 class="isle-attribute-detail-title">{{ selectedAttributeItem ? selectedAttributeItem.title : 'No Selection' }}</h4>
            <div class="tooltip-text" [innerHtml]="selectedAttributeItem?.toolTip"></div>
            <button class="isle-attribute-detail-close" (click)="hideItemDetails()">Hide Info</button>
        </div>
    </div>
</div>
